'use client';
import type { FC, PropsWithChildren } from 'react';
import { useCallback, useMemo, useRef, useState } from 'react';

import { useModal } from '~hooks/useModal';
import { HeaderContext } from '~widgets/Header/context';

export const HeaderContextProvider: FC<PropsWithChildren> = ({ children }) => {
	const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
	const [headerOffset, setHeaderOffset] = useState(0);
	const headerRef = useRef(null);

	const {
		isOpen: isLanguageOpen,
		open: languageOpen,
		close: languageClose,
	} = useModal();

	const sideMenuClose = useCallback(() => {
		setIsSideMenuOpen(false);
	}, []);

	const toggleSideMenu = useCallback(() => {
		setIsSideMenuOpen((it) => !it);
	}, []);

	const value = useMemo(
		() => ({
			headerRef,
			headerOffset,
			isSideMenuOpen,
			isLanguageOpen,
			sideMenuClose,
			toggleSideMenu,
			setHeaderOffset,
			languageOpen: () => {
				languageOpen()();
			},
			languageClose: () => {
				languageClose();
			},
		}),
		[
			headerOffset,
			isSideMenuOpen,
			isLanguageOpen,
			sideMenuClose,
			toggleSideMenu,
			languageOpen,
			languageClose,
		]
	);

	return (
		<HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>
	);
};
